import React from 'react';

function ViewTabs({ viewManager, views, activeIndex }) {
  if (!viewManager) return null;

  return (
    <div className="h-9 bg-white border-t border-gray-200 flex items-center px-2 gap-1 shrink-0">
      {views.map((view, i) => (
        <button
          key={i}
          onClick={() => viewManager.switchView(i)}
          className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
            view.active
              ? 'bg-primary-500 text-white'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          {view.name}
        </button>
      ))}
      <button
        onClick={() => {
          const name = views.length === 1 ? 'Rückseite' : `Ansicht ${views.length + 1}`;
          viewManager.addView(name);
        }}
        className="px-2 py-1 rounded text-xs text-gray-400 hover:text-gray-600 hover:bg-gray-100"
        title="Ansicht hinzufügen"
      >
        +
      </button>
      {views.length > 1 && (
        <button
          onClick={() => {
            if (window.confirm('Ansicht entfernen?')) {
              viewManager.removeView(activeIndex);
            }
          }}
          className="px-2 py-1 rounded text-xs text-gray-400 hover:text-red-500 hover:bg-red-50 ml-auto"
          title="Aktive Ansicht entfernen"
        >
          <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}

export default ViewTabs;
